import React, { } from 'react';
import EditorParent from '@/base-components/EditorParent';

const DemoPage: React.FC = () => {
    return (
        <EditorParent title="Demo" description="Mapbox demo">
            Nothing to see here yet.
        </EditorParent>
    );
};

export default DemoPage;

